module.exports = __webpack_public_path__ + "static/media/check-circle.b66362e8.svg";